import { atom, useAtomValue } from "jotai";

export interface FailedUploadData {
  errorMessage: string;
}

export interface FailedUploads {
  [releaseTrackId: number]: FailedUploadData;
}

/**
 * Failed upload data for SupplyChain.
 * Stores error messages for failed verifications to display to the Artist.
 */
const supplyChainFailedUploadsAtom = atom<FailedUploads>({});

export interface AddFailedUploadParams {
  releaseTrackId: number;
  failedData: FailedUploadData;
}

export const addFailedUploadAtom = atom(
  (get) => get(supplyChainFailedUploadsAtom),
  (get, set, { releaseTrackId, failedData }: AddFailedUploadParams) => {
    set(supplyChainFailedUploadsAtom, {
      ...get(supplyChainFailedUploadsAtom),
      [releaseTrackId]: failedData,
    });
  },
);

export const removeFailedUploadAtom = atom(
  (get) => get(supplyChainFailedUploadsAtom),
  (get, set, releaseTrackId: number) => {
    const current = get(supplyChainFailedUploadsAtom);
    const { [releaseTrackId]: _, ...updatedFailed } = current;
    set(supplyChainFailedUploadsAtom, updatedFailed);
  },
);

export const useGetFailedTrackFileStatus = (releaseTrackId: number) => {
  const failed = useAtomValue(supplyChainFailedUploadsAtom);
  return failed[releaseTrackId];
};
